module.exports = {"450621100":"思阳镇","450621101":"在妙镇","450621102":"华兰镇","450621103":"叫安镇","450621203":"南屏瑶族乡","450621204":"平福乡","450621205":"那琴乡","450621206":"公正乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450621.json
// module id = 2250
// module chunks = 0